module.exports = __webpack_public_path__ + "img/Dantam Makeover 07.48d464c4.jpg";